<style>
  .UnSubmit {
    background-color: #ff9595 !important;
  }
</style>

<div class="col-md-12 mb-30" style="margin-top: 20px;" [hidden]="DataList_Kartable_Selected_DeviceBehfa.id>0">
  <div class="card card-statistics h-100">
    <div class="card-body">
      <h5 class="card-title border-0 pb-0">Instruments without Certificates for Receipt Number '{{inner_Calibration.code}}'</h5>

      <br />
      <br />


      <div class="row">
        <div class="form-group col-md-6">
          <button *ngIf="!Procssing_Kartable" type="button" (click)="ReadData_Kartable()" class="btn btn-info"
            style="margin-right: 5px;"><i class="fa  fa-search"></i> Search
          </button>
          <a href="{{BaseUrl}}Daro/Kartable/GetCalibrationInLocationDownloadDeviceBehfa?id={{this.inner_Calibration.id}}" target="_blank" *ngIf="!Procssing_Kartable" type="button" class="btn btn-danger"
            style="margin-right: 5px;"><i class="fa   fa-file-excel-o"></i> Behfa Equipment </a>
          <button (click)="OnSet_Back_CalibrationList()" type="button" class="btn btn-warning"><i
              class="fa fa-mail-reply"></i>
            Back </button>
          <img *ngIf="Procssing_Kartable" src="assets/Loading.gif" style="width: 25px;" />
        </div>
      </div>

      <div class="row">
        <div class="col-md-6 mb-30" *ngFor="let item of DataList_Kartable
        | paginate
                : {
                    id: 'DataList_Kartable',
                    itemsPerPage: 20,
                    currentPage: page_Kartable,
                    totalItems: DataList_Kartable.length
                  }
        ">
          <div class="card h-100" [ngClass]="{'UnSubmit': item.controller.length>0}">
            <div class="card-body">
              <p><span style="font-weight: 600;">Certificate Address </span> '{{item.customer_address_certificate}}' </p>
              <hr />
              <div style="float: left;">
                <p><span style="font-weight: 600;">Instrument</span> {{item.controller.length}} '{{item.devicename}}' </p>
              </div>
              <br />
              <hr />
              <div style="float: left;">
                <p><span style="font-weight: 600;">Instrument Code </span> '{{item.code}}' </p>
                <p><span style="font-weight: 600;">Instrument Serial Number</span> '{{item.serial}}' </p>
              </div>
              <div style="float: right;">
                <p><span style="font-weight: 600;">Delivery Date </span> '{{item.tarikhTahvi}}' </p>
              </div>
              <div style="clear: both;"></div>

              <hr />

              <span  *ngIf="item.flowchartRequestDsc">
                <p><span  style="font-weight: 600;">Restore Certificate</span>  '{{item.flowchartRequestDsc}}' </p>
                <hr/>
              </span>   

              <p><span style="font-weight: 600;">Tariff Description</span> '{{item.tariff_dsc}}' </p>

              <hr />

              <img *ngIf="item.Processing" src="assets/Loading.gif" style="width: 25px;" />


              <div *ngIf="!item.Processing && item.status!='کنترل'">

                <div class="row" *ngIf="!item.src">
                  <div class="form-group col-md-12">

                    <button type="button" (click)="OnSet_Calibration_DeviceBehfa(item,0)" style="margin-right: 10px;"
                      class="btn btn-info">
                      <i class="fa fa-building"></i> Behfa Equipment
                    </button>

                    <button type="button" class="btn btn-success" (click)="openModal_upload(templateUpload,item)"><i
                        class="fa fa-upload"></i> Upload Calibration Certificate </button>
                    <a style="margin-left: 10px;" *ngIf="item.filename" target="_blank"
                      href="{{BaseUrl}}File/Calibration/{{item.filename}}" class="btn btn-info"><i
                        class="fa fa-eye"></i> View Calibration Certificate File </a>
                    <button type="button" *ngIf="item.filename" (click)="SubmitExpertCalibrationDate(item)"
                      style="margin-top: 10px;" class="btn btn-warning"><i class="fa fa-check"></i> Submit for Review
                      Certificate </button>
                    <button type="button" *ngIf="item.controller.length>0"
                      (click)="openModal_Controller(templateController,item)"
                      style="margin-top: 10px;margin-left: 10px;" class="btn btn-danger"><i class="fa fa-file"></i>
                      Reviewer Messages </button>

                    <button (click)="openModal_LetterFile(templateLetterFile,item)" type="button"
                      class="btn btn-warning" style="margin-left: 5px;">
                      <i class="fa fa-file"></i> Additional Customer Information
                    </button>
                  </div>
                </div>

                <div class="row" *ngIf="item.src">
                  <a target="_blank" style="margin-top: 10px;margin-left: 10px;"
                    [routerLink]="[item.src,{id:item.calibration_detail_id}]" type="button" class="btn btn-success"><i
                      class="fa fa-file-code-o"></i> Enter Data </a>
                  <a style="margin-left: 10px;" *ngIf="item.certificate" target="_blank"
                    href="{{BaseUrl}}{{item.certificate}}" class="btn btn-info"><i class="fa fa-eye"></i> View File
                    Certificate </a>
                  <button type="button" *ngIf="item.certificate" (click)="SubmitExpertCalibrationDate(item)"
                    style="margin-top: 10px;" class="btn btn-warning"><i class="fa fa-check"></i> Submit Certificate for Review
                    </button>
                  <button type="button" *ngIf="item.controller.length>0"
                    (click)="openModal_Controller(templateController,item)" style="margin-top: 10px;margin-left: 10px;"
                    class="btn btn-danger"><i class="fa fa-file"></i> Reviewer Messages </button>


                  <button (click)="openModal_LetterFile(templateLetterFile,item)" type="button" class="btn btn-warning"
                    style="margin-left: 5px;">
                    <i class="fa fa-file"></i> Additional Customer Information
                  </button>

                </div>

              </div>



              <div *ngIf="!item.Processing && item.status=='کنترل'">
                <h6 style="color: rgb(18 88 11);"> Certificate submitted for review. </h6>
              </div>

            </div>
          </div>

        </div>

      </div>

      <pagination-controls id="DataList_Kartable" nextLabel="Next" previousLabel="Previous"
        (pageChange)="page_Kartable = $event"></pagination-controls>


    </div>
  </div>
</div>

<app-CalibrationDeviceBehfa *ngIf="DataList_Kartable_Selected_DeviceBehfa.id>0"
  (OnBack_CalibrationDeviceBehfa_Action)="OnSet_Back_Calibration_DeviceBehfa($event)"
  [inner_Kartable_Order_Interface]="DataList_Kartable_Selected_DeviceBehfa"
  [inner_Can_Add_Edit]="CanModify_Kartable_Selected_DeviceBehfa" [inner_Persian_Date]="">

</app-CalibrationDeviceBehfa>

<ng-template #templateUpload>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> Calibration Certificate File '{{Selected_DataList_Calibration.devicename}}' </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_upload.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="card-body">
      <div class="row">
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1"> Select File </label>
          <input #file type="file" (change)="onFileSelected($event)" class="form-control">
        </div>
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1"> Certificate Code </label>
          <input [(ngModel)]="certificate_user_code" name="certificate_user_code" type="text" class="form-control"
            placeholder="Type here...">
        </div>
      </div>
    </div>

  </div>
  <div class="modal-footer">
    <img *ngIf="ProcssingUpload" src="assets/Loading.gif" style="width: 25px;" />
    <button *ngIf="!ProcssingUpload" type="button" (click)="upload(file.files)" class="btn btn-info"
      style="margin-right: 5px;"><i class="fa  fa-upload"></i> Upload File </button>
    <button type="button" class="btn btn-danger" (click)="modalRef_upload.hide()">Close</button>
  </div>
</ng-template>

<ng-template #templateController>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> Reviewer Messages '{{Selected_DataList_Calibration.devicename}}' </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Controller.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="card-body">
      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>Description</th>
              <th>User</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of Controller_Data_List">
              <td>{{Controller_Data_List.indexOf(item)+1}}</td>
              <td>{{item.dsc}}</td>
              <td>{{item.title}}</td>
              <td>{{item.code}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-danger" (click)="modalRef_Controller.hide()">Close</button>
  </div>
</ng-template>

<ng-template #templateLetterFile>
  <div class="modal-header">
    <h4 class="modal-title pull-left">  Attached Files </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_LetterFile.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="card-body">
      <h6 class="modal-title" style="float: right;">   Letter Number Customer '{{LetterFile_Data_Code}}' </h6>
      <h6 class="modal-title" style="float: left;">   Customer Letter Date '{{LetterFile_Data_Tarikh}}' </h6>
      <div style="clear: both;"></div>
      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>File</th>

            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of LetterFile_Data_List">
              <td>{{LetterFile_Data_List.indexOf(item)+1}}</td>
              <td>
                <a target="_blank"  href="{{BaseUrl}}File/Letter/{{item}}"
                class="btn btn-success"><i class="fa fa-download"></i> View </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-danger" (click)="modalRef_LetterFile.hide()">Close</button>
  </div>
</ng-template>

<table id="excel-table" style="display: none;">
  <thead>
    <tr>
      <th>Description</th>
      <th></th>
      <th>Manufacturer</th>
      <th></th>
      <th>Model</th>
      <th></th>
      <th>ID</th>
      <th></th>
      <th>Certificate No</th>
      <th></th>
      <th>Cal due</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let item of DataList_Calibration_Device">
      <td>{{item.description}}</td>
      <td></td>
      <td>{{item.manufacturer}}</td>
      <td></td>
      <td>{{item.model}}</td>
      <td></td>
      <td>{{item.codeBEHFA}}</td>
      <td></td>
      <td>{{item.certificateNo}}</td>
      <td></td>
      <td>{{item.calDueMiladi}} _</td>
    </tr>
  </tbody>
</table>
